import React, { useState } from "react";
import { Tabs as RawTabs, Tab } from "@material-ui/core";
import parse from "url-parse";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import ToolbarStyle from "../ToolbarStyle";

const useStyles = makeStyles((theme) => ({
  tabs: (props) => ({
    marginTop: 16,
    background: props.primaryColor ? theme.palette.primary.main : "white",
    "&.MuiTabs-root": {
      minHeight: 0,
    },
    "& .MuiTab-root:first-child": {
      marginLeft: theme.spacing(1),
    },
    "& .MuiTab-root": {
      minWidth: 0,
      minHeight: 0,
    },
    "& .MuiTab-textColorPrimary": {
      color: props.primaryColor ? "rgba(255, 255, 255, 0.6)" : undefined,
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: props.primaryColor ? "white" : undefined,
    },
    "& .MuiTabs-indicator": {
      background: props.primaryColor ? "white" : undefined,
    },
  }),
  tabEnd: {
    minWidth: 20,
  },
  gradientWrapper: {
    position: "relative",
    pointerEvents: "none",
    flex: 1,
  },
  gradient: (props) => ({
    background: `linear-gradient(90deg, transparent 0%, ${
      props.primaryColor ? theme.palette.primary.main : "white"
    } 100%)`,
    position: "absolute",
    right: 0,
    height: "100%",
    width: 20,
    pointerEvents: "none",
  }),
  tabPanel: {
    maxHeight: 400,
    overflow: "auto",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
  };
}

function Tabs(props) {
  const classes = useStyles(props);
  const { tabs, TabPanelProps, toolbarContent, primaryColor, location } = props;
  const [selectedTab, setSelectedTab] = useState(
    location ? parseInt(parse(location.search, true).query.tab || 0, 10) : 0
  );

  const changeTab = (tab) => {
    setSelectedTab(tab);
    if (location) {
      const params = parse(location.search, true).query;
      params.tab = tab;
      window.history.replaceState(
        null,
        null,
        `?${_.map(_.toPairs(params), function (param) {
          return `${param[0]}=${param[1]}`;
        }).join("&")}`
      );
    }
  };

  return (
    <React.Fragment>
      <ToolbarStyle primaryColor={primaryColor}>
        <RawTabs
          className={classes.tabs}
          value={selectedTab}
          onChange={(event, newTab) => changeTab(newTab)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={`tab-${index}`}
              value={index}
              label={tab.name}
              {...a11yProps(index)}
              className={classes.tab}
            />
          ))}
          <div className={classes.tabEnd} />
        </RawTabs>
        <div className={classes.gradientWrapper}>
          <div className={classes.gradient} />
        </div>
        {toolbarContent}
      </ToolbarStyle>
      {tabs.map((tab, index) => (
        <TabPanel
          key={`tab-panel-${index}`}
          className={classes.tabPanel}
          value={selectedTab}
          index={index}
          {...TabPanelProps}
        >
          {tab.content}
        </TabPanel>
      ))}
    </React.Fragment>
  );
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Tabs/index.jsx